import React, { useState } from 'react';
import Box from '@mui/material/Box';
import tokens from '../../theme/tokens';

export const teamImage = (nome = '') => `/times/${nome.replace(/ /g, '_')}.png`;

// Escudo do time (public/times/<Nome_Do_Time>.png) com fallback para a sigla.
const TeamCrest = ({ name = '', size = 40, sx }) => {
  const [failed, setFailed] = useState(false);

  if (failed || !name) {
    return (
      <Box
        sx={{
          width: size,
          height: size,
          borderRadius: '50%',
          bgcolor: tokens.color.ink,
          color: '#fff',
          display: 'grid',
          placeItems: 'center',
          fontWeight: 700,
          fontSize: size * 0.34,
          flexShrink: 0,
          ...sx,
        }}
      >
        {name.slice(0, 3).toUpperCase()}
      </Box>
    );
  }

  return (
    <Box
      component="img"
      src={teamImage(name)}
      alt={name}
      onError={() => setFailed(true)}
      sx={{ width: size, height: size, objectFit: 'contain', flexShrink: 0, ...sx }}
    />
  );
};

export default TeamCrest;
